export enum EntityTypeSR {
    Legal = 'Pravno lice',
    Physical = 'Fizičko lice',
}

export enum SiteTypeSR {
    ConstructionSite = 'Gradilište',
    Warehouse = 'Magacin',
    Depot = 'Depo',
}

export enum ClientTypeSR {
    Customer = 'Klijent',
    Supplier = 'Dobavljač',
}

export enum DemandAction {
    Transfer = 'Transfer',
    Sell = 'Sell',
    Reserve = 'Reserve',
}

export enum DemandActionSR {
    Sell = 'Prodaj',
    Transfer = 'Prebaci',
    Reserve = 'Rezerviši',
}

export enum GoodsStatusSR {
    InStock = 'Na stanju',
    Sold = 'Prodato',
    WrittenOff = 'Otpisano',
    Used = 'Ugrađeno',
    InTransport = 'U transportu',
    Ordered = 'Naručeno',
}

export enum OrderTypeSR {
    GeneralReturn = 'Povratnica',
    Demand = 'Trebovanje',
    Transfer = 'Nalog za prenos',
    Reception = 'Nalog za prijem',
}

export enum OrderStatusSR {
    Idle = 'Kreiran',
    Pending = 'Na čekanju',
    Approved = 'Odobren',
    Transport = 'U transportu',
    Delivered = 'Dostavljen',
    Returned = 'Vraćen',
    Cancelled = 'Otkazan',
}

export enum SpecializedOrderStatusSR {
    Created = 'Kreiran',
    InProgress = 'U izvršavanju',
    Closed = 'Izvršen',
    Delivered = 'Dostavljen',
    Cancelled = 'Otkazan',
}

export enum ReceiptTypeSR {
    Transfer = 'Prenosnica',
    Return = 'Povratnica',
    Delivery = 'Dostavnica',
    Reception = 'Prijemnica',
}

export enum DimensionTypeSR {
    Quantity = 'Br. komada',
    Weight = 'Težina',
    Length = 'Dužina',
}

export enum DimensionTypeDimensionSR {
    Quantity = 'kom.',
    Weight = 'kg',
    Length = 'm',
}

export enum CompleteOrderType {
    GeneralReturn = 'GeneralReturn',
    Demand = 'Demand',
    Transfer = 'Transfer',
    Reception = 'Reception',
}
